(function($) {

    $('.js-burger-menu').on('click', function() {
        $('body').addClass('no-scroll');
        $('.header .header__collapse').addClass('show');
    });

    $('.js-close-menu').on('click', function() {
        $('body').removeClass('no-scroll');
        $('.header .header__collapse').removeClass('show');
    });

    $('.header .nav-item.dropdown > a').on('click', function(e) {
        e.preventDefault();

        let $item = $(this),
            $parent = $item.parent();

        $parent.toggleClass('open');
    });

    const currentUrl = new URL(window.location.href);
    const currentPath = currentUrl.pathname.replace(/\/+$/, '');
    const currentHost = currentUrl.hostname;

    document.querySelectorAll('.nav-link, .dropdown-item').forEach(link => {
        const href = link.getAttribute('href');
        if (!href || href === '#' || href.startsWith('#')) return;

        const linkUrl = new URL(href, window.location.href);
        const linkPath = linkUrl.pathname.replace(/\/+$/, '');
        const linkHost = linkUrl.hostname;

        if (currentPath === linkPath && currentHost === linkHost) {
            link.classList.add('active');

            const dropdown = link.closest('.dropdown');
            if (dropdown) {
                const toggle = dropdown.querySelector('.dropdown-toggle');
                toggle?.classList.add('active');
            }
        }
    });

}) (jQuery);